import { render, staticRenderFns } from "./EditBookAndChapterList.vue?vue&type=template&id=368e277d"
import script from "./EditBookAndChapterList.vue?vue&type=script&lang=js"
export * from "./EditBookAndChapterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports